var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2DC4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.155 9.036c1.071 0 2.178-.072 3.25.024.476.535.583 1.285.952 1.904 4.81.024 9.643 0 14.453 0 .357.024.797.036.976.393.214.393.06.857-.143 1.214-.976 1.655-1.905 3.334-2.857 5-.357.596-.596 1.262-1.131 1.727-.44.369-1.048.392-1.607.392H12.38c-.357 0-.738-.035-.952-.321-.69-.774-1.06-1.762-1.512-2.667a246.634 246.634 0 01-2.298-4.726c-.155-.357-.345-.678-.524-1.012-.63 0-1.262 0-1.88-.024-.12-.63-.12-1.273-.06-1.904zm7.512 11.94a3.428 3.428 0 011.476-.024c.547.12 1.024.536 1.155 1.084.142.63.142 1.31-.108 1.916-.238.548-.833.81-1.392.858-.643.047-1.381 0-1.858-.477-.511-.571-.511-1.404-.404-2.119.071-.595.547-1.107 1.13-1.238zm5.952 0c.595-.13 1.238-.119 1.81.095.547.227.833.822.88 1.381.072.655 0 1.405-.476 1.905-.44.417-1.083.476-1.666.464-.572-.023-1.19-.238-1.488-.773a2.817 2.817 0 01-.215-1.87c.12-.583.572-1.07 1.155-1.202z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStq);
export default __webpack_public_path__ + "static/media/stq.be3b6387e97c870a66072ef56e76a580.svg";
export { ForwardRef as ReactComponent };